<template>
  <div class="parts">
    <div class="part part-1">
      <p class="subtitle light-text">Aprenda sobre os direitos e legislações da mulher brasileira!</p>
      <img class="logo block-center" src="@/assets/images/logo_trans.png">
      <img class="logo sublogo block-center" src="/android-chrome-512x512.png">
      <!-- <h1 class="logo"> -->
      <!--   <span class="light-text">Direitos e</span> -->
      <!--   <br> -->
      <!--   <span class="sec-text">Silêncios</span> -->
      <!-- </h1> -->
    </div>
    <div class="part part-2">
      <btn-x class="play-btn" :to="{ name: 'game'}">Jogar</btn-x>
      <div class="double-btn">
        <btn-x class="small-btn" :to="{ name: 'tutorial'}">Instruções</btn-x>
        <btn-x class="small-btn" :to="{ name: 'about'}">Sobre</btn-x>
      </div>
      <div class="double-btn">
        <btn-x class="small-btn no-back-btn" @click="toggleFullscreen">
            <svg svg-inline="" class="icon" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.635 31.632" height="31.632" width="31.635"><path d="M31.635 11.593h-2.31V2.31h-8.29V0h10.6zM31.635 31.632h-10.6v-2.31h8.29v-9.284h2.31zM10.599 31.632H0V20.038h2.31v9.284h8.289zM2.31 11.593H0V0H10.6v2.31h-8.29z" fill="#fff"/></svg>
        </btn-x>
        <btn-x class="small-btn no-back-btn" @click="toggleAudio">
            <svg v-if="mute" svg-inline="" class="icon" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.303 35.301" height="35.301" width="35.303"><path d="M1.857 17.65c0-3.578 1.21-6.87 3.224-9.522l6.368 5.603v8.384h6.8l5.604 5.604v-3.08l4.855 4.27c-2.852 2.802-6.755 4.535-11.057 4.535-8.71 0-15.794-7.085-15.794-15.793m31.588 0c0 3.576-1.208 6.865-3.22 9.517l-6.372-5.605V7.583l-5.604 5.604h-3.918L6.6 6.388c2.85-2.799 6.75-4.53 11.05-4.53 8.71 0 15.795 7.085 15.795 15.793M17.651 0C7.919 0 0 7.917 0 17.65c0 9.734 7.919 17.651 17.65 17.651 9.735 0 17.653-7.917 17.653-17.65C35.303 7.917 27.385 0 17.65 0" fill="#fff"/></svg>
            <svg v-else="" svg-inline="" class="icon" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.303 35.303" height="35.303" width="35.303"><path d="M17.65 1.859c-8.707 0-15.793 7.084-15.793 15.793 0 8.708 7.086 15.793 15.794 15.793 8.709 0 15.794-7.085 15.794-15.793 0-8.71-7.085-15.793-15.794-15.793m0 33.444C7.919 35.303 0 27.385 0 17.652S7.919 0 17.65 0c9.735 0 17.653 7.919 17.653 17.652s-7.918 17.65-17.652 17.65" fill="#fff"/><path d="M23.854 7.584l-5.604 5.604h-6.8v8.927h6.8l5.604 5.605z" fill="#fff"/></svg>
        </btn-x>
      </div>
    </div>
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  data () {
    return {
      mute: this.$audioConf._muted
    }
  },
  methods: {
    toggleFullscreen () {
      if (screenfull.enabled) {
        screenfull.toggle()
      } else {
        alert('A funcionalidade de tela cheia parece não suportada por esse navegador. Por favor, tente em outro.')
      }
    },
    toggleAudio () {
      if (this.mute) {
        this.$audioConf.mute(false)
        this.mute = false
      } else {
        this.$audioConf.mute(true)
        this.mute = true
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/vars.scss';
// .logo {
  //   font-size: 50pt;
  //   line-height: 40pt;
  //   margin: 0 0 50px 0;
  //   .sec-text {
    //     text-shadow: $shadow-color 2px -3px 0;
    //   }
  // }
.block-center {
  display: block;
  margin: auto;
}
.logo {
  max-width: 90%;
  max-height: 8rem;
}
.sublogo {
  max-height: 10rem;
  margin: 2rem auto;
}
.subtitle {
  text-transform: uppercase;
  font-size: 10pt;
}
.play-btn {
  max-width: 350px;
  height: 150px;
  font-size: 60pt;
  padding: 1rem;
  /* box-shadow: $shadow-color 7px 7px 0px; */
}
.small-btn {
  max-width: 45%;
}
.no-back-btn {
  background: 0;
  border: 0;
  margin: 0;
  width: 3rem;
  &:hover, &:focus {
    background: 0;
  }
  &:after {
    content: "";
    background: 0;
    border: 0;
  }
}
.double-btn {
  display: flex;
  max-width: 350px;
  margin: auto;
  justify-content: center;
}
.parts {
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    .part-2 {
      padding: 0;
    }
  }
  .part {
    flex: none;
  }
}
.part-2 {
  padding: 0rem 4rem;
}
</style>
